import { LeftArrowIcon } from '@/components/Icons';
import { Button } from 'ui/mobile-ds';
import { twConfig } from 'ui/ds/utils/getConfig';
import get from 'lodash.get';
import { ArrowLeft } from 'ui/icons';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { motion } from 'framer-motion';

interface IProps {
  onBack: () => void;
  theme?: 'dark' | 'light';
  className?: string;
  bg?: string;
  style?: React.CSSProperties;
  title?: string | null;
  sticky?: boolean;
  rightAction?: React.ReactNode;
}

const BackButtonBar = ({
  onBack,
  theme,
  className,
  bg,
  style,
  title,
  rightAction,
  sticky,
}: IProps) => {
  return (
    <div
      id="claims-back-bar"
      className={twMerge(
        clsx({
          'h-12 lg:h-auto py-3 lg:pt-2 px-4 lg:px-0 w-full lg:w-auto': true,
          [`${bg}`]: bg,
          '!sticky !top-0 left-0 z-10': sticky,
        }),
        className,
      )}
      style={style}
    >
      <div className="flex justify-between items-center">
        <Button
          className="min-w-0 h-6 lg:h-auto active:bg-transparent active:opacity-80"
          prefixIcon={() => (
            <>
              <LeftArrowIcon
                className="block lg:hidden"
                color={
                  theme === 'dark'
                    ? 'white'
                    : get(twConfig, 'theme.colors.retail.text.main')
                }
              />
              <ArrowLeft className="hidden lg:block" />
            </>
          )}
          intent="tertiary"
          onClick={onBack}
        />
        {title ? (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-mobile-text-main text-sm text-center font-medium leading-5"
          >
            {title}
          </motion.p>
        ) : null}
        {rightAction ? rightAction : title ? <div className="w-6 h-6" /> : null}
      </div>
    </div>
  );
};

export default BackButtonBar;
